// Anchor scroll with offset for the fixed navbar.
// NOTE: this runtime only applies scroll changes made synchronously within the
// click handler (async/animated scroll is blocked), so we jump synchronously.
export const smoothScrollTo = (sel, offset = 80) => {
  const el = document.querySelector(sel);
  if (!el) return;
  const targetY = Math.max(0, window.scrollY + el.getBoundingClientRect().top - offset);
  window.scrollTo(0, targetY);
};
